import {
  type CommonECommerceEventItemWithOptionalList,
  buildBaseTrackingItem
} from './buildBaseTrackingItem';
import type { Category } from '../graphql/categories/findOneCategoryWithParentsByCode';
import type { ListContext } from './listContextStorage';
import type { Price } from '@spa/lib/getPriceValues';
import type { Product } from '../graphql/products/findOneProductDetailedByCode';

type CommonECommerceEventItemCategory = Pick<Category, 'name'>;

type CommonECommerceEventItemProduct = Pick<
  Product,
  | 'campaignPrice'
  | 'code'
  | 'name'
  | 'currentPrice'
  | 'ownBrand'
  | 'strikePrice'
  | 'recommendedRetailPrice'
  | 'stockLevelIndication'
  | 'preOrderSettings'
> & {
  brand: CommonECommerceEventItemCategory | null;
  categoryWithParents: readonly CommonECommerceEventItemCategory[];
  badges: ReadonlyArray<string> | null;
  lowestVariantPrice?: Price | null;
};

type ConvertProductToCommonECommerceEventItemType = {
  product: CommonECommerceEventItemProduct;
  listContext?: ListContext;
  country: string;
  preOrderEnabled: boolean;
  pricesIncludeTax: boolean;
};

export type { CommonECommerceEventItemWithOptionalList };

export const convertProductToCommonECommerceEventItem = (
  props: ConvertProductToCommonECommerceEventItemType
): CommonECommerceEventItemWithOptionalList => {
  const { product, listContext, country, preOrderEnabled, pricesIncludeTax } = props;
  const {
    code,
    name,
    brand,
    currentPrice,
    categoryWithParents,
    campaignPrice,
    strikePrice,
    recommendedRetailPrice,
    lowestVariantPrice,
    badges,
    stockLevelIndication,
    preOrderSettings
  } = product;

  const categoryNames: ReadonlyArray<string> = categoryWithParents.map(({ name }): string => {
    return name;
  });

  return buildBaseTrackingItem({
    id: code,
    name,
    brandName: brand?.name ?? null,
    categoryNames,
    listContext,
    badges,
    stockLevelIndication,
    preOrderSettings,
    preOrderEnabled,
    pricesIncludeTax,
    country,
    price: currentPrice.valueWithoutTax,
    prices: {
      currentPrice,
      campaignPrice,
      strikePrice,
      recommendedRetailPrice,
      lowestVariantPrice
    }
  });
};
